// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gportal/type/v1/localized_error.proto (package gportal.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message gportal.type.v1.LocalizedError
 */
export class LocalizedError extends Message<LocalizedError> {
  /**
   * @generated from field: string translation_key = 1;
   */
  translationKey = "";

  /**
   * @generated from field: map<string, string> arguments = 2;
   */
  arguments: { [key: string]: string } = {};

  constructor(data?: PartialMessage<LocalizedError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.type.v1.LocalizedError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "translation_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "arguments", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LocalizedError {
    return new LocalizedError().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LocalizedError {
    return new LocalizedError().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LocalizedError {
    return new LocalizedError().fromJsonString(jsonString, options);
  }

  static equals(a: LocalizedError | PlainMessage<LocalizedError> | undefined, b: LocalizedError | PlainMessage<LocalizedError> | undefined): boolean {
    return proto3.util.equals(LocalizedError, a, b);
  }
}

